export default __webpack_public_path__ + "static/media/add.4a0c56a9.svg";